<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Checkbox/NewDCheckboxEditor'
export default {
  name: 'NewDReleasePlatformEditor',
  extends: compoment
}
</script>
